import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-result-sign-vneid-popup',
  templateUrl: './result-sign-vneid-popup.component.html',
  styleUrls: ['./result-sign-vneid-popup.component.scss']
})
export class ResultSignVneidPopupComponent implements OnInit {
  type: string = '';
  title: string = '';
  message: string = '';
  constructor(
    public dialogRef: MatDialogRef<ResultSignVneidPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = false;
    this.type = this.data.type;
    this.title = this.data.title;
    this.message = this.data.message;
  }

  ngOnInit(): void {}

  onNoClick(isSuccess: boolean = true): void {
    this.dialogRef.close(isSuccess);
  }
  
}